/*!
 * slick.min.js
 https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.0/slick.min.js
 */
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});
// (c) Copyright 2016 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
// See https://docs.shopify.com/themes/customization/navigation/link-product-options-in-menus
  
// Modified by Jonathan Moore (Style Hatch) https://github.com/jonathanmoore
/* 
  Updated to work with sectioned themes
      - Added required methods from the deprecated options_selection.js
        - Triggers an initial variant change
        - Hides sold out variants with only one option
*/

var colorFound = false;
var sizeFound = false;
var variantAvailable = true;

window.addEventListener('DOMContentLoaded', function() {
  var Shopify = Shopify || {};
    
  // Required functionality from depricated options_selection.js
  Shopify.arrayIncludes = function(e, t) {
    for (var n = 0; n < e.length; n++)
        if (e[n] == t) return !0;
    return !1
  }, Shopify.uniq = function(e) {
      for (var t = [], n = 0; n < e.length; n++) Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
      return t
  }

  Shopify.optionsMap = {};
  var opt1;
  var opt2;
  var opt3;   
  Shopify.updateOptionsInSelector = function(selectorIndex) {
    //console.log('selectorIndex:'+selectorIndex);
    switch (selectorIndex) {
      case 0:
        var key = 'root';
        var selector = jQuery('.single-option-selector:eq(0)'); 
        break;
      case 1:
        var key = jQuery('.single-option-selector:eq(0)').val();
        var selector = jQuery('.single-option-selector:eq(1)');
        break;
      case 2:
        var key = jQuery('.single-option-selector:eq(0)').val();  
        key += ' / ' + jQuery('.single-option-selector:eq(1)').val();
        var selector = jQuery('.single-option-selector:eq(2)'); 
    }
    
    var initialValue = selector.val();
    selector.empty();    
    var availableOptions = Shopify.optionsMap[key];

    // console.log('availableOptions');
    // console.log('key:'+key);
    // console.log(Shopify.optionsMap);
    // console.log(availableOptions);
    
    // console.log(availableOptions.length); 

    $('.customizeSection').attr('data-key', key);

    if (availableOptions != undefined) {  
      for (var i=0; i<availableOptions.length; i++) {
        var option = availableOptions[i];
        var newOption = jQuery('<option></option>').val(option).html(option);
        selector.append(newOption);
      }
      jQuery('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
        if (jQuery.inArray($(this).attr('data-value'), availableOptions) !== -1) {
          //$(this).removeClass('soldout').show().find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
          $(this).removeClass('unavailable').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
        }
        else {
          //$(this).addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled','disabled');
          $(this).addClass('unavailable').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
        }
      });
      if (jQuery.inArray(initialValue, availableOptions) !== -1) {
        selector.val(initialValue);
      } else {
        selector.val(availableOptions[0]);    
      }
    }  
  };


  Shopify.linkMainVariant = function() {
    //console.log('linkMainVariant');
    opt1 = '';
    opt2 = '';
    opt3 = '';  
    if ($('select.single-option-selector:eq(0)').not('.bundleSelect').length > 0) {
      opt1 = $('.single-option-selector:eq(0)').val();
    } 
    if ($('select.single-option-selector:eq(1)').not('.bundleSelect').length > 0) {
      opt2 = ' / '+$('.single-option-selector:eq(1)').val();
    }
    if ($('select.single-option-selector:eq(2)').not('.bundleSelect').length > 0) {
      opt3 = ' / '+$('.single-option-selector:eq(2)').val();
    } 
    //console.log(opt1+opt2+opt3);
    //selector.trigger('change');
    //console.log(opt1+opt2+opt3);

    var optsTitle = opt1+opt2+opt3;
    if (optsTitle == '') {
      optsTitle = 'Default Title'
    }
  
    var mainVariant = $('.product-form__variants[name="id"]');
    var mainVariantOption = mainVariant.find('option[data-title="'+optsTitle+'"]')
    var selectedVariant = mainVariantOption.attr('value');
    var selectedVariantAvailability = mainVariantOption.attr('data-available');
    
    mainVariant.val(selectedVariant).trigger('change');

    var hasPrescription = mainVariantOption.data('prescription');

    $('.mainForm').attr('data-prescription', hasPrescription)
    if (hasPrescription == 'true') {

    } else {
      $('.mainForm  #prescription').val('');
    }

    $('.product__price .price').removeClass('price--unavailable');
    if (selectedVariantAvailability == 'true') {
      // available
      $('.newPDP').attr('data-available', true);
      $('.product-form__cart-submit').attr('aria-label', theme.strings.addToCart).attr('aria-disabled', false).find('[data-add-to-cart-text]').text(theme.strings.addToCart);
      $('.customizeBtn').removeAttr('disabled').attr('aria-label', $('.customizeBtn .avail').text());

      $('.add-to-home-tryon-btn').removeAttr('disabled');
      variantAvailable = true;
      $('[data-sticky-atc-add]').removeClass('is-disabled');
    } else  {
      // soldout
      $('.newPDP').attr('data-available', false);
      $('.product-form__cart-submit').attr('aria-label', theme.strings.soldOut).attr('aria-disabled', true).find('[data-add-to-cart-text]').text(theme.strings.soldOut);
      $('.customizeBtn').attr('disabled', 'disabled').attr('aria-label', $('.customizeBtn .soldOut').text());

      $('.add-to-home-tryon-btn').attr('disabled', 'disabled');
      variantAvailable = false;
      $('[data-sticky-atc-add]').addClass('is-disabled');
    }
    $('[data-sticky-atc-variant]').text(optsTitle); 
    //$('.main-product-variants').attr();
    var sizeMapValue = $('.main-product-variants option:selected').attr('data-size-map');
    if (sizeMapValue != '') {
      $('.sizeText').text(sizeMapValue);
      $('.main-product-variants').attr('data-size-map', sizeMapValue);
    }

    

    var winLoc = window.location.href;
    
    history.replaceState(null, null, replaceUrlParam(winLoc, 'variant', mainVariant.val()));
    setTimeout(function() {
      var varImg = $('.main-product-variants option:selected').attr('data-image');
      $('.atcurl').val(window.location.href);    
      $('.atcimage').val(varImg);    
    }, 100);

  };  

  Shopify.updateVariantPrice = function() {
    console.log('updateVariantPrice');
    var mainTotalPrice = 0;
    var mainVariantOpt = $('.product-form__variants[name="id"] option:selected');
    var mainTotalPrice = parseInt(mainVariantOpt.attr('data-price')); 

    $('.bundleSelect').each(function() {
      var bundlePrice = parseInt($(this).find('option:selected').attr('data-price')); 
      mainTotalPrice += bundlePrice;
    });
    $('.product__price .price-item--regular').text(Shopify.formatMoney(mainTotalPrice));

    var updateTimer;  
    $('.afterpay-paragraph .afterpay-instalments').hide();
    

    
    if (typeof Afterpay != 'undefined') {
      afterpay_current_variant.price = mainTotalPrice;
      //$('afterpay-placement, square-placement').remove();
      Afterpay.init($);
      clearTimeout(updateTimer);
      updateTimer = setTimeout(function(){  
      $('.afterpay-box square-placement').first().nextAll('square-placement').remove()
      }, 300);
    }
    

  };  

  Shopify.linkOptionSelectors = function(product) {
    //console.log('linkOptionSelectors..');
    // Building our mapping object.
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      if (true) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
        Shopify.optionsMap['root'].push(variant.option1);
        Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    // When there is an update in the first dropdown.
    
    jQuery(".single-option-selector:eq(0)").change(function() {
        //console.log('change1');
      Shopify.updateOptionsInSelector(1);
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
      return true;
    });
    // When there is an update in the second dropdown.
    jQuery(".single-option-selector:eq(1)").change(function() {
        //console.log('change2');
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
      return true;
    });  
    jQuery('select.single-option-selector').not('.bundleSelect').change(function() {
      Shopify.linkMainVariant();
      return true;
    });    
  };
   

  //var selector = jQuery('.single-option-selector:eq(0)');
  //selector.trigger('change'); 
  Shopify.linkOptionSelectors(productJSON);
  Shopify.linkMainVariant();

  $('.product-form__controls-group .swatch').each(function() {
    var optIndex = $(this).attr('data-option-index');
    var selectVal =  $('#SingleOptionSelector-'+optIndex).val();
    $(this).find('input[value="'+selectVal+'"]').prop('checked', true);
  });

});
var altArray = [];
var customizeTotal = 0;
var currentStep = 1;
var skipSteps = [];
var prescriptionFlag = false;
var productProperty = [];
var productBundle = [];
var activeSteps = [];
Shopify.queue = []; 
var lensStep = ''; 

var advOptsArr = [];
var advImgsArr = [];
var nonPrescOpt = '';

var appliedCode = theme.custom.appliedDiscountCode;
var appliedDiscount = 0;
var discountFlag = false;
var discount100Decimal = 1;


if (theme.custom.advOpts != undefined) {
    advOptsArr = theme.custom.advOpts.split('| ');
}
if (theme.custom.advImgs != undefined) {
    advImgsArr = theme.custom.advImgs.split('| ');
}

var currentGalleryIndex = 0;
$(document).ready(function() {
    
// if $('.newPDP').length
if ($('.newPDP').length > 0) {  
    referrerParam()  
    if (getQueryParams(document.location.search)['atcsource'] == 'lp') {
        $('.mainForm #atcsrc').val('Landing Page');
        $('.customizeForm #atcsrc').val('Landing Page');
    }
    // push unique color to array
    $('.mainGallery li[data-alt]').each(function() {
        var altVal = $(this).data('alt');
        if ($.inArray(altVal, altArray) == -1) {
            altArray.push(altVal);
        }
    });
    var prevSlick = '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 32 32"><path fill="#000000" d="M24.333 28.205l-1.797 1.684L7.666 16l14.87-13.889 1.797 1.675L11.269 16z"/></svg></button>';
    var nextSlick = '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 32 32"><path fill="#000000" d="M7.667 3.795l1.797-1.684L24.334 16 9.464 29.889l-1.797-1.675L20.731 16z"/></svg></button>'

    // slick slider main gallery
    console.log('aaaaaaaaa');
    $('.mainGallery').slick({ 
        infinite: true,
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true, 
        fade: false,
        dots: true, 
        asNavFor: '.tmbNav',
        prevArrow: prevSlick,
        nextArrow: nextSlick 

    });
    $(".tmbNav").slick({ 
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.mainGallery',
        lazyLoad: 'ondemand',
        focusOnSelect: true,
        prevArrow: prevSlick,
        nextArrow: nextSlick,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3
              }
            }
          ]
    });

    $('.tmbNav').on('afterChange', function(event, slick){
        //console.log(slick)
        //console.log(slick.currentSlide)
        currentGalleryIndex = slick.currentSlide;
    });


    // disable main gallery link
    $('body').on('click', '.gallerySlide a', function() {
      return false;
    });

    var variant_id = $(".mainForm [name='id'] option:selected").attr('value');
    if (variant_id == null) {
        variant_id = $(".mainForm [name='id'] option").first().attr('value'); 
    }
    var optImage = '';
    var optImage2 = '';
    if (__variants[variant_id].featured_image != null) {
        optImage = __variants[variant_id].featured_image.src.replace('.jpg?', '_1600x1600.jpg?').replace('.png?', '_1600x1600.png?')
        optImage2 = __variants[variant_id].featured_image.src.replace('.jpg?', '_640x640.jpg?').replace('.png?', '_640x640.png?')
        $('.optionModalImage .optionImage').each(function() {
            $(this).find('.imageBox').html('<img src="'+optImage+'" loading="lazy" />');
        }); 
        $('.optionBody .optionImage').each(function() {
            $(this).find('.imageBox').html('<img src="'+optImage2+'" loading="lazy" />');
        }); 
    }
       

    var hasColorImage = false;
    $('select.single-option-selector[data-name="Color"] option').each(function() {
        $(this).attr('value');
        if (__variants[variant_id].featured_image.alt != null) {
            if ($(this).attr('value') == $.trim(__variants[variant_id].featured_image.alt).split(' | ')[0]) {
                hasColorImage = true;
            }
        }
    });
    //console.log('hasColorImage:'+hasColorImage);

    $('body').on('change', 'select.single-option-selector', function() {
        var scrollPos =    $(window).scrollTop(); 
        var dataName = $(this).attr('data-name');
        var filter = '';
        if (hasColorImage == true) {
            if (dataName == 'Color') {
                filter = $('select.single-option-selector[data-name="Color"] option:selected').val();
                if (filter == undefined) {
                    filter = '';    
                }
                filter = filter.replace(/\W+(?!$)/g, '-').toLowerCase();
                filter = filter.replace(/\W$/, '').toLowerCase();
                $('.newPDP').data('selected-color', filter);
                $('.productMainBox .swatch-element').removeClass('filterSelected');
                $(this).addClass('filterSelected');

                filterGallery(filter, scrollPos, currentGalleryIndex);
            } 
        } else {
            variant_id = $(".mainForm [name='id'] option:selected").attr('value');
            optImage = __variants[variant_id].featured_image.src.replace('.jpg?', '_1600x1600.jpg?').replace('.png?', '_1600x1600.png?');
            $('.optionModalImage .optionImage').each(function() {
                $(this).find('.imageBox').html('<img src="'+optImage+'" loading="lazy" />');
            });
            $('.optionBody .optionImage').each(function() {
                $(this).find('.imageBox').html('<img src="'+optImage2+'" loading="lazy" />');
            }); 
            $('.productSlider').slick('slickGoTo', __variants[variant_id].featured_image.position - 1);
        }    
    });
    document.querySelectorAll('.swatch .swatch-element').forEach((el) => {
      el.addEventListener('touchstart', function (e) {
        // Remove active class from all first
        document.querySelectorAll('.swatch .swatch-element').forEach(s => s.classList.remove('active'));

        // Add active class to the touched one
        this.classList.add('active');
        
        // Simulate click to select variant
        this.click();

        // Prevent the event from bubbling to document
        e.stopPropagation();
      });
    });

    // Add listener to remove active class (tooltip) on outside touch/click
    document.addEventListener('touchstart', function (e) {
      const isInsideSwatch = e.target.closest('.swatch .swatch-element');
      if (!isInsideSwatch) {
        document.querySelectorAll('.swatch .swatch-element').forEach(s => s.classList.remove('active'));
      }
    });
    // auto select onload option
    if (hasColorImage == true) {
        var selectedColor = $('.newPDP').data('selected-color');
        //console.log('selectedColor:'+selectedColor);    
        filterGallery(selectedColor, $(window).scrollTop(), currentGalleryIndex);
    } 
    $('body').on('change', '.product-form__variants[name="id"], select.bundleSelect, .multiOption', function() { 
      updatePrice(); 
    });
    $('body').on('change', '.product-form__variants[name="id"]', function() { 
        if (hasColorImage == false) {
            var variant_id = $(this).find('option:selected').attr('value');
            //console.log('galPos'+__variants[variant_id].featured_image.position -)
        }
    });    
    // add tooltip modal
    $('.pdpLabelPopBox').each(function() {
        var pdpLabel = $(this).data('label');
        var triggerElem = $(this).find('.pdpLabelPop');
        var labelElem = $('.product-form__controls-group label[data-label="' + pdpLabel + '"]');

        if (labelElem.length > 0) {
            labelElem.find('.pdpLabelPop').remove();
            triggerElem.clone().appendTo(labelElem);
        }
    });

    // submit main form
    $('.mainForm').keydown(function(event) {
        if(event.keyCode == 13) {
            event.preventDefault();
        }
    });
    $('body').on('click', '.product-form__cart-submit', function() {
        // add loader clear properties and submit form
        $('body').addClass('ajaxLoading');
        $('.addOnProperties').html('');
        $('.product-form__cart-submit').attr('aria-label', theme.strings.addingToCart).attr('aria-disabled', true).find('[data-add-to-cart-text]').text(theme.strings.addingToCart);
        setTimeout(addtoCartAddons, 10);
        return false;
    });
    
    // auto select motivation
    var age = localStorage.getItem('collection_selected_age');
    var sport = localStorage.getItem('collection_selected_sport');

    if (age != null) {
        var tag = age;
        $(".tg-affirmations").find("[data-tag='" + tag + "']").addClass("show_strong");
    }
    if (sport != null) {
        var tag = sport;
        $(".tg-affirmations").find("[data-tag='" + tag + "']").addClass("show_strong");
    }

    // auto select add on based on url attribute
    if ($('body').hasClass('template-product')) {
        var addOnsVal = getQueryParams(document.location.search)['Addons'];
        var addOnArray = [];
        if (addOnsVal != undefined) {
            var addOnsArr = addOnsVal.split(';');
            if (addOnsArr.length > 0) {
                //$('body').addClass('hasAddOns');
                //var cartButton = '<a href="/cart" class="btn secondary-btn cart-btn">Go to Cart</a>'
                //$('.product-form__item--submit').append(cartButton); 
            }
            $.each(addOnsArr, function(index, addOnItem) {
                $('.mainForm  .product-form__item input[value="' + addOnItem + '"]').prop('checked', true).trigger('change');
                if ($('.mainForm  .single-option-selector option[value="' + addOnItem + '"]').length > 0) {
                  $('.mainForm  .single-option-selector option[value="' + addOnItem + '"]').parent().val(addOnItem).trigger('change');
                }
                addOnArray.push(addOnItem);
            });
        }
        pushItem($('.mainForm'), addOnArray, 'Viewed Product');
    }

    // modal on load

    $('body').on('click', '.customizeBtn', function() {
        $.ajaxSetup({
            async: false
        }); 
        if ($('.customizeSection  *').length == 0) {
            loadCustomizer()
        }
        $.ajaxSetup({
            async: true 
        }); 

        $('body').addClass('optionOpen');
        setTimeout(function(){ 
             $('body').addClass('optionOpened');
        }, 1);
        // selected variant
        var variantSelected = $('.main-product-variants option:selected').attr('data-option1');
        if ($('.main-product-variants option:selected').attr('data-option2') != '') {
          variantSelected = variantSelected+' - '+$('.main-product-variants option:selected').attr('data-option2');
        }
        if ($('.main-product-variants option:selected').attr('data-option3') != '') {
          variantSelected = variantSelected+' - '+$('.main-product-variants option:selected').attr('data-option3');
        }
        $('.optionModalBox .prodInfo .variantSelected').text(variantSelected);

        updateOptionProgress(currentStep)
    });

    $('body').on('click', '.option-close', function() {
        $('body').removeClass('optionOpened');
        setTimeout(function(){ 
             $('body').removeClass('optionOpen');
        }, 600);
       
    });

    // prev next
    var changeTimer;
    $('body').on('click', '.nextOption', function() {
        //prevStep = currentStep;
        //changeStep(1);
        $('.optionStep[data-step="'+currentStep+'"] input:checked').trigger('click')
    });
    $('body').on('click', '.backOption', function() {
        var stepsSize = activeSteps.length;
        currentStep = activeSteps[stepsSize-1]; 
        // get last step in array then remove
        //console.log('currentStep:'+currentStep);
        $('.optionModalBox').attr('data-current-step', currentStep);        
        $('.optionStep[data-step="'+currentStep+'"]').find('.noAdv input:checked').attr('data-advance', 0); 
        activeSteps.splice(-1);


        checklensButton(currentStep);
        updateOptionProgress(currentStep); 
       
    });

    $('.optionStep  .uploadField').val('');

    var optsActionHTML  = '<span class="actionBox"><button type="button" class="chooseMe">Choose this lens</button><button type="button" class="cancel">Cancel</button></span>';


    
    
    $('body').on('click', '.actionBox .cancel', function() {
        $(this).closest('label').find('input[type="radio"]').prop('checked', false).attr('data-advance', 0);  
    });

    $('body').on('click', '.actionBox .chooseMe', function() {
        $('.optionSelect label').each(function() {
            var optInput = $(this).find('input[type="radio"]');
            var optTitle = optInput.attr('data-value');
            //console.log('advOptsArr');
            //console.log(advOptsArr);
            var inArr = $.inArray(optTitle, advOptsArr); 
            if (inArr > -1) {
                $(this).addClass('noAdv');
                optInput.attr('data-advance', 0);
            }
        });

        $(this).closest('fieldset').find('label input').attr('data-advance', 0);
        $(this).closest('label').find('input[type="radio"]').attr('data-advance', 1).trigger('click');
    });

    
    $('body').on('click', '.optionSelect label input[type="radio"]', function() {
        //console.log('opt change');
        var thisOption = $(this);
        var thisOptionStep  = thisOption.closest('.optionStep');
        var thisFieldset = thisOption.closest('.optionSelect');
        var thisPriceTxt = thisOption.closest('label').find('em').text();
        var dataAdvance = parseInt(thisOption.attr('data-advance')); 
        var dataOptName = thisOption.closest('.optionSelect').attr('data-option');
        var dataOptValue = thisOption.val();
        var dataOptType = thisFieldset.attr('data-type');
        var nextOptionAttr = thisOption.attr('data-next-option');
        var labelElem = $(this).closest('label'); 

        var filter = $('select.single-option-selector[data-name="Color"] option:selected').val();
        if (filter === undefined) {
            filter = '';
        }
            filter = filter.replace(/\W+(?!$)/g, '-').toLowerCase();
            filter = filter.replace(/\W$/, '').toLowerCase();

        var scrollPos = $(window).scrollTop();    
        filterGallery(filter, scrollPos, currentGalleryIndex);  

        thisFieldset.attr('data-value', dataOptValue);
        var thisFieldsetVal = thisFieldset.attr('data-value');

       
        
        // show hide upload
        if (thisOption.attr('name') == 'prescription-option') {
            if (thisOption.attr('data-upload') == 'false') {
                $('.optionStep .uploadField').val('');
                $('.optionStep .uploadFieldBox').attr('data-valid', false); 
                thisFieldset.attr('data-upload', false);
            } else {
                thisFieldset.attr('data-upload', true);
            }
        }     

        // trigger next  
        clearTimeout(changeTimer); 
        changeTimer = setTimeout(function(){ 
            
            // if (labelElem.hasClass('noAdv')) {
            //     if (thisOption.prop('checked')) {
            //         return false;
            //     }
            // }
            //prescription_type
            if (thisFieldset.attr('data-option').toLowerCase().indexOf('prescription') > -1) {
                // if non prescription
                if (thisOption.attr('data-value').toLowerCase().indexOf('non-prescription') > -1 ) {
                    prescriptionFlag = false;  
                    $('.optionStep .uploadField').val('');
                    $('.optionStep .uploadFieldBox').attr('data-valid', false); 
                } else {
                    prescriptionFlag = true;  
                }
            }
            //console.log('prescriptionFlag:'+prescriptionFlag); 
            if (prescriptionFlag == false) {
                $('.optionSlider .optionStep.prescriptionStep').prev().find('.optionSelect input:radio').attr('data-advance', 2)
            } else {
                $('.optionSlider .optionStep.prescriptionStep').prev().find('.optionSelect input:radio').attr('data-advance', 1)
            }

            if (dataAdvance > 0) {
                // push active steps to array
                var stepIndex = $.inArray(currentStep, activeSteps);
                if (currentStep > 1) {
                    if (stepIndex > 0) {
                        // remove suceeding steps
                        activeSteps.splice(stepIndex, 100);
                    }
                    // push current step to array
                    activeSteps.push(currentStep);
                } else {
                    // set array to 1
                    activeSteps = [1];
                }
                
                // set step
                if (thisOption.attr('data-next-step') != undefined) {
                    // custom step
                    var customStepVal = parseInt($('.optionStep[data-option="'+thisOption.attr('data-next-step')+'"]').attr('data-step'));
                    currentStep = customStepVal;
                    $('.optionModalBox').attr('data-current-step', customStepVal);     

                    updateOptionProgress(customStepVal);
                } else {
                    // normal advance
                    changeStep(dataAdvance);  
                }    
            } 
            // upload field check
            if (thisOption.attr('data-upload') == 'true') {
                // if not empty advance to next step
                if (thisFieldset.find('.uploadField').val() != '') {
                    activeSteps.push(currentStep);
                    changeStep(1);
                }
            }
            if (dataOptType == 'option') {
                //trigger option change
                $('select.single-option-selector[data-name="'+dataOptName+'"]').val(dataOptValue).trigger('change');
            }
            if (dataOptType == 'bundle') {
                //bundle pass variant price
                thisFieldset.attr('bundle-price', thisOption.attr('data-price'));
                thisFieldset.attr('data-bundle', thisOption.val()); 
            } 
            // pass property to fieldset
            thisFieldset.attr('data-value', thisOption.attr('data-value')); 
            thisFieldset.attr('data-price-text', thisPriceTxt);     
            
            // show hide next step option
            if (typeof nextOptionAttr !== 'undefined' && nextOptionAttr !== false && thisOption.attr('data-next-option') != '') {
                // lens color: grey| amber
                var nextOptArr = nextOptionAttr.split(': ');
                var nextOptKey = nextOptArr[0];
                var nextOptValArr = nextOptArr[1].split('| ');
                $('.optionStep[data-option="' + nextOptKey + '"] .optionSelect  label').hide();

                // console.log('nextOptionAttr');
                // console.log(nextOptionAttr);
                // console.log('nextOptKey');
                // console.log(nextOptKey);

                $.each(nextOptValArr, function(index, item) {
                    $('.optionStep[data-option="' + nextOptKey + '"] .optionSelect  input[data-value-lowercase="' + item + '"]').closest('label').show();
                    //console.log(item);
                });
            } else {
                if (thisOption.attr('data-advance') == 1) {
                    thisOptionStep.next('.optionStep').find('.optionSelect label').show();
                }
                
            }

            //update total
            var mainProductPrice = parseInt($('.main-product-variants option:selected').attr('data-price'));
            var bundlePrice = 0;
            $.each(activeSteps, function(index, item) {
                var thisBundle = $('.optionStep[data-step="' + item + '"] .optionSelect.bundleSelect');
                var bundleItemPrice = parseInt(thisBundle.attr('bundle-price'));
                if (isNaN(parseInt(bundleItemPrice)) == false) {
                    bundlePrice += bundleItemPrice;
                }
            });


            

            var customTotalPrice = mainProductPrice + bundlePrice;
            var customTotalPriceHTML = Shopify.formatMoney(customTotalPrice);

  

            if (prescriptionFlag && discountFlag) {
                customTotalPriceHTML = '<span class="sale">'+Shopify.formatMoney(customTotalPrice * discount100Decimal)+'</span> <s>'+Shopify.formatMoney(customTotalPrice)+'</s>';
            }  

            //console.log('customizeTotal', customTotalPriceHTML);



            $('.customizeTotal').html(customTotalPriceHTML);
            $('.customizeForm #atcprice').val((customTotalPrice/100).toFixed(2));
            checklensButton(currentStep);
            showHideOpts(); 
        }, 150);
        
    }); 
    
    // auto advance on file upload change
    $('body').on('change', '.optionStep  .uploadField', function() {
        setTimeout(function(){ 
        }, 600);    
            activeSteps.push(currentStep);
            changeStep(1);
            $('.optionStep .uploadFieldBox').attr('data-valid', true); 
        
    });
    // $('body').on('click', '.uploadFieldBox .uploadBtn', function() {
    //   activeSteps.push(currentStep);
    //   changeStep(1);
    // });
    $('.optionSelect input').prop('checked', false);
    $('body').on('click', '.customizeAdd', function() {
        $('html, body').addClass('ajaxLoading');
        setTimeout(function() {
            $('#customTimestamp').val(Math.floor(Date.now() / 1000));
            var bundleCount = 0;
            // non async submit to prevent issue 
            $.ajaxSetup({
                async: false
            }); 
            var bundleTitle = $('.optionModalWrapper').attr('data-title');
            var parentID = $('.optionModalWrapper').attr('data-id');
            var ts = $('#customTimestamp').val();
            var bundleIDs = [];
            $.each(activeSteps.reverse(), function(index, item) {
                var thisBundle = $('.optionStep[data-step="'+item+'"] .optionSelect.bundleSelect');   
                var bundleProperty = {};
                var bundleID = thisBundle.attr('data-bundle');
                var bundlePrice = parseInt(thisBundle.attr('bundle-price'));
                
                if (isNaN(bundlePrice)) {
                    bundlePrice = 0;
                }
                
                if (bundlePrice > 0) {
                    bundleCount += 1;
                    bundleProperty['_Product Title'] = bundleTitle;
                    bundleProperty['_Product ID'] = parentID;
                    bundleProperty['_Timestamp'] = ts;
                    bundleProperty['_HR'] = '-----';
                    
                    
                    
                   
                    // console.log('aaaa');
                    // console.log(params);
                    //console.log('bbb', bundleID);
                    if (bundleID.indexOf(',') > 0) {
                        // multiple sekection like coating 
                        var bundleArr = bundleID.split(',');
                        $.each( bundleArr, function( key, value ) {
                            var params = {
                                quantity: 1,
                                id: value
                            };
                            params.properties = bundleProperty;
                            //console.log('bbb multiple', params);
                            $.ajax({
                                type: 'POST',
                                url: '/cart/add.js',
                                async: false,
                                dataType: 'json',
                                data: params,
                                success: function() {
                                    // if (typeof callback === 'function') {
                                    //     callback();
                                    // }
                                },
                                error: function() {}
                            });
                        });
                        
                    } else {
                        var params = {
                            quantity: 1,
                            id: bundleID
                        };
                        bundleIDs.push(bundleID);
                        params.properties = bundleProperty;
                        //console.log('bbb single bundle', params);
                        
                        $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            async: false,
                            dataType: 'json',
                            data: params,
                            success: function() {
                                // if (typeof callback === 'function') {
                                //     callback();
                                // }
                            },
                            error: function() {
                                alert('error single');
                            }
                        });
                        
                    }
                    
                    // console.log('bundleProperty');
                    //push_to_queue2(bundleID, 1, bundleProperty, Shopify.moveAlong2);
                }
            });

            if (prescriptionFlag == false && nonPrescOpt != '') {
   
                var nonPrescOptArr = nonPrescOpt.split('; ');
                $.each( nonPrescOptArr, function( key, value ) {
                    var valueArr = value.split(':');
                    var xKey = valueArr[0];
                    var xValue = valueArr[1];

                    var bundlePrice = parseInt($('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').attr('data-price'));

                    var customKey = $('.bundleStep[data-handle="'+xKey+'"] .optionSelect').attr('data-option').split(': ')[0];
                    var customPrice = $('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').closest('label').find('em').text();
                    var customValueID = $('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').closest('label').attr('data-value');

                    if (bundlePrice > 0) {
                        // console.log(customKey);
                        // console.log(customValueID);

                        var bundleProperty = {};

                        bundleProperty['_Product Title'] = bundleTitle;
                        bundleProperty['_Product ID'] = parentID;
                        bundleProperty['_Timestamp'] = ts;
                        bundleProperty['_HR'] = '-----';
                        var params = {
                            quantity: 1,
                            id: customValueID
                        };
                        bundleIDs.push(customValueID);
                        params.properties = bundleProperty;
                        
                        //console.log('bbbb');
                        // console.log(params);
                        
                        $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            async: false,
                            dataType: 'json',
                            data: params,
                            success: function() {
                                // if (typeof callback === 'function') {
                                //     callback();
                                // }
                            },
                            error: function() {}
                        }); 
                        
                        
                    }
                    
                });
            } 
            // submit form
            var customProp = {};
            
            $('.customizeForm .customProperties .customProp').each(function() {
                customProp[$(this).attr('title')] = $(this).val();
            });

            


            
            bundleIDs.push($('#customVariantID').val());
            $('.customProperties').append('<input type="hidden" name="properties[_BundleIDs]" value="'+bundleIDs+'">');    

            //console.log('bbb submit main product', bundleIDs);
            pushItem($('.mainForm'), addOnArray, 'Added to Cart', customProp);

    
            $('.customizeForm').submit();
            $.ajaxSetup({
                async: true
            });
        }, 10);
        return false;

    });
    $('body').on('click', '.customizeEdit', function() {
        currentStep = 1;
        $('.optionModalBox').attr('data-current-step', currentStep);
        updateOptionProgress(currentStep) 
    });    
    $('[data-show-option] [data-option-index]').each(function() {
        var optionValue = $(this).find('input:checked').val();
        $(this).find('[data-selected-opt]').text(optionValue);
    });
    $('.swatch :radio').change(function() {
        
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        var optionSelect = $(this).closest('form').find('.selector-wrapper[data-option="'+optionIndex+'"] .single-option-selector');

        var exists = false;
        optionSelect.find('option').each(function(){
            if (this.value == optionValue) {
                exists = true;
                return false;
            }
        })  
        //console.log('swatch change', optionValue);
        setTimeout(function() {
            $('[data-show-option] [data-option-index]').each(function() {
                var optionValue = $(this).find('input:checked').val();
                $(this).find('[data-selected-opt]').text(optionValue);
            });
        }, 10);

        //console.log('optionIndex: '+optionIndex); 
        // second option
        if (optionIndex == 1) {
            //console.log('optionValue:'+optionValue);

            var opt1Val = $('.selector-wrapper[data-option="0"]').val();
            var firstAvailOpt1 = $('.main-product-variants option[data-option2="' + optionValue + '"][data-available="true"]').first().attr('data-option1');

            //var firstAvailOpt1 = $('.main-product-variants option[data-option1="' + opt1Val + '"][data-option2="' + optionValue + '"][data-available="true"]').first().attr('data-option1');


            var opt1 = $('.single-option-selector[data-index="option1"]').val();
            var propAvail = $('.main-product-variants option[data-option1="' + opt1 + '"][data-option2="' + optionValue + '"]').attr('data-available');

            //console.log('firstAvailOpt1:'+firstAvailOpt1);
            //console.log('propAvail:'+propAvail);

            // if undefined not unAvailable select first available
            if (propAvail === undefined) {
                $('.product-form__controls-group input[value="'+firstAvailOpt1+'"]').prop('checked', true);
                $('select.product-form__input[data-index="option1"]').val(firstAvailOpt1).trigger('change');
            } else {
                if (exists) {
                    optionSelect.val(optionValue).trigger('change');
                }
            }
            $('select.product-form__input[data-index="option2"]').val(optionValue).trigger('change');
        } else {
            if (exists) {
                optionSelect.val(optionValue).trigger('change');
            }
        }
        // filter swatch
        filterSwatches();
        //setTimeout(filterSwatches, 100);
    });




    // auto select based on attributes
    var sizeMapArr = $('[data-size-mapping]').attr('data-size-mapping').split(', ');
    var filterQuery = getQueryParams(document.location.search);
    var filterColor = filterQuery.color;
    var filterSize = filterQuery.eye_size;
    var filterWidth = filterQuery.width;
    var colorFound = false;
    var sizeFound = false;
    var widthFound = false;
    
    // check if color exist
    if (filterColor != '' && filterColor != undefined ) {
        //alert(filterColor)
      if ($('.main-product-variants option[data-option1-h="'+filterColor+'"]').length > 0) {
        colorFound = true;
        $('#swatch-0-'+filterColor).prop('checked', true).trigger('change');  
      }
    }  

    // check if size exist
    var sizeVal;
    if (filterSize != '' && filterSize != undefined ) {
        var sizeVal = capitalizeFirstLetter(filterSize);
        console.log('sizeVal:'+sizeVal);

        if ($('.pdpActionBox').length > 0) {
            // // PDP v2
            var sizeOptVal = '';
            $.each( sizeMapArr, function( key, value ) {
                var xV = value;
                if (xV.split(':')[0].split(' [')[0] == sizeVal) {
                    sizeOptVal = xV.split(':')[1]; 
                }
            });
            var sizeFound = $('.swatch[data-label="size"] .swatch-element[data-value*="'+sizeOptVal+'"]').not('.unavailable').length;
            if (sizeFound == 0 && sizeOptVal == 'Medium') {
                sizeOptVal = 'Average';
                sizeFound = $('.swatch[data-label="size"] .swatch-element[data-value*="'+sizeOptVal+'"]').not('.unavailable').length;
            }
            if (sizeFound > 0) {
               $('.swatch[data-label="size"] input[value*="'+sizeOptVal+'"]').prop('checked', true).trigger('change');
            }
        } else {
            // old pdp
            var sizeOptVal = '';
            $.each( sizeMapArr, function( key, value ) {
                var xV = value;
                if (xV.split(':')[0].split(' [')[0] == sizeVal) {
                    sizeOptVal = xV.split(':')[0]; 
                }
            });
            var widthFound = $('.single-option-selector[data-name="Size"] option[value="'+sizeOptVal+'"]').length;
            if (widthFound > 0) {
                $('.single-option-selector[data-name="Size"]').val(sizeOptVal).trigger('change');
            }

        }  
    } 
    // check if width exist

    if (filterWidth != '' && filterWidth != undefined ) {
        var widthVal = capitalizeFirstLetter(filterWidth); 

        if ($('.pdpActionBox').length > 0) {
            // PDP v2
            var widthFound = $('.swatch[data-label="size"] .swatch-element[data-value*="'+widthVal+'"]').length;
            if (widthFound == 0 && widthVal == 'Medium') {
                widthVal = 'Average';
                widthFound = $('.swatch[data-label="size"] .swatch-element[data-value*="'+widthVal+'"]').length;
            }
            
            if (widthFound > 0) {
                setTimeout(function() { 
                    $('.swatch[data-label="size"] input[value*="'+widthVal+'"]').prop('checked', true).trigger('change');
                }, 300);
            }
        } else {
            // old pdp
            var sizeOptVal = '';
            $.each( sizeMapArr, function( key, value ) {
                var xV = value;
                if (xV.split(':')[1] == widthVal) {
                    sizeOptVal = xV.split(':')[0]; 
                }
            });
            var widthFound = $('.single-option-selector[data-name="Size"] option[value="'+sizeOptVal+'"]').length;
            if (widthFound > 0) {
                $('.single-option-selector[data-name="Size"]').val(sizeOptVal).trigger('change');
            }
        }  
    }
    
    
    // auto select size


    if (sizeFound) {
        if ($('.pdpActionBox').length > 0) {
            $('.boxSwatch .swatch-element input[value="'+sizeVal+'"]').prop('checked', true).trigger('change');
        } else {
            // old pdd
            var sizeVal = $('#SingleOptionSelector-1 option[value*="'+filterSize+'"]').val();
            $('#SingleOptionSelector-1').val(sizeVal).trigger('change');
        }    
    }
    /*
    if (widthFound) {
      if ($('.pdpActionBox').length > 0) {
        // swatch click pdp v2
        //widthValue = $('.main-product-variants option[data-option2*="'+widthVal+'"]').attr('data-option2');  
        $('.boxSwatch .swatch-element input[value="'+widthValue+'"]').prop('checked', true).trigger('change');
      } else {
        // old pdp
        $('#SingleOptionSelector-1').val(widthValue).trigger('change');
      }      
    }
    */


    var winLoc = window.location.href;
    var filterQuery = getQueryParams(document.location.search);

    if (filterQuery.color != '' && filterQuery.color != undefined ) {
      winLoc = winLoc.replace('color='+filterQuery.color +'&', '')
    }  
    if (filterQuery.eye_size != '' && filterQuery.eye_size != undefined ) {  
      winLoc = winLoc.replace('eye_size='+filterQuery.eye_size +'&', '')
    }  
    if (filterQuery.width != '' && filterQuery.width != undefined ) {  
      winLoc = winLoc.replace('width='+filterQuery.width +'&', '')
    }  

    history.replaceState(null, null, winLoc);
    

    // unique array
    Array.prototype.unique =
      function() {
        var a = [];
        var l = this.length;
        for(var i=0; i<l; i++) {
          for(var j=i+1; j<l; j++) {
            // If this[i] is found later in the array
            if (this[i] === this[j])
              j = ++i;
          }
          a.push(this[i]);
        }
        return a;
    };

    $('body').on('click', '.chatOpen', function() {
        zE(function() {
        zE.activate();
        });  
    });


    $('body').on('click', '.progressMark dt.checked', function() {
        var thisStep = parseInt($(this).attr('data-step'));
        $('.progressMark  dt.active').removeClass('active');
        $(this).addClass('active');
        changeStep(thisStep - currentStep);
    });  
}
// end if $('.newPDP').length

    $(window).click(function() {
          //Hide the menus if visible
      $('.dropBtn').removeClass('exp');
    });

    $('body').on('click', '.chooseLens', function(event) {
      $('.optionSelect .noAdv input:checked').closest('.noAdv').find('.chooseMe').trigger('click');
      return false;
    });

    $('body').on('click', '.dropBtn .btn', function(event) {
      event.stopPropagation();
        $(this).closest('.dropBtn').toggleClass('exp');
      return false;
    });

    $('select.single-option-selector[data-name="Color"]').trigger('change');
    showHideBundleOpt();    

    // hide out of stock variant
    var hideColorVariant = $('#hideColor').val();
    if (hideColorVariant != '') {
        var hideColorVariantArr = hideColorVariant.split(', '); 
        $.each(hideColorVariantArr, function(index, value) {
            console.log("Index: " + index + ", Value: " + value);
          $('.mainForm .swatch-element[data-value="'+value+'"]').addClass('hide');
        });
        $('.mainForm .swatch-element:not(.hide):first label').trigger('click');
    }

  
});//  end ready

$('body').on('change', '.bundleSelect', function() {
   showHideBundleOpt();    
}); 
var changeTimer2;
$('body').on('change', '.optionStep input[type="checkbox"]', function() {
    var thisOption = $(this);
    var thisOptionStep = thisOption.closest('.optionStep');
    var thisFieldset = thisOption.closest('.optionSelect');
    var dataOptType = thisFieldset.attr('data-type');
    var totalPrice = 0;
    var pricetext = '';
    var selArr = [];
    var selTextArr = [];
    thisFieldset.find('input[type="checkbox"]:checked').each(function() {
        var thisOption = $(this);
        var optionPrice = parseInt(thisOption.attr('data-price'));
        totalPrice += optionPrice;
        selArr.push(thisOption.val());
        selTextArr.push(thisOption.attr('data-value'));
    });
    if (totalPrice > 0) {
        pricetext = '+$' + (totalPrice / 100).toFixed(0)
    } else {
        pricetext = '';
    }
    var stepInputChecked = thisFieldset.find('input:checked').length;
    thisOptionStep.find('.multiSelectAction button').hide(); 
    if (stepInputChecked > 0) {
        thisOptionStep.find('.multiActionYes').show(); 
    } else {
        thisOptionStep.find('.multiActionNo').show(); 
    }


    clearTimeout(changeTimer2); 
    changeTimer2 = setTimeout(function(){ 
        thisFieldset.attr('data-price-text', pricetext);
        thisFieldset.attr('bundle-price', totalPrice);
        thisFieldset.attr('data-bundle', selArr.toString());
        thisFieldset.attr('data-value', selTextArr.toString());
        var bundlePrice = 0;
        console.log(activeSteps);

        var mainProductPrice = parseInt($('.product-form__variants[name="id"] option:selected').attr('data-price'));
        $.each(activeSteps, function(index, item) {
            var thisBundle = $('.optionStep[data-step="' + item + '"] .optionSelect.bundleSelect');
            var bundleItemPrice = parseInt(thisBundle.attr('bundle-price'));
            if (isNaN(parseInt(bundleItemPrice)) == false) {
              console.log(bundleItemPrice);
                bundlePrice += bundleItemPrice;
            }
        });
        bundlePrice += parseInt(thisFieldset.attr('bundle-price'));
        var customTotalPrice = mainProductPrice + bundlePrice;
        console.log(bundlePrice);
        
        let customTotalPriceHTML = '';
        if (prescriptionFlag && discountFlag) {
            customTotalPriceHTML = '<span class="sale">'+Shopify.formatMoney(customTotalPrice * discount100Decimal)+'</span> <s>'+Shopify.formatMoney(customTotalPrice)+'</s>';
        } else {
            customTotalPriceHTML = Shopify.formatMoney(customTotalPrice);
        }  
        //console.log('customizeTotal', customTotalPriceHTML);
        $('.customizeTotal').html(customTotalPriceHTML);



    }, 150);    
});
$('body').on('click', '.multiSelectAction .btn', function() {
    var thisOption = $(this).closest('.optionStep').find('.optionSelect input');
    var nextOpt = $(this).closest('.optionStep').next('.optionStep').attr('data-option');
    var dataAdvance = parseInt(thisOption.attr('data-advance'));    
    if (prescriptionFlag == false) {
        dataAdvance = dataAdvance + 1
    }
    //console.log(dataAdvance);
  activeSteps.push(currentStep);  
  changeStep(dataAdvance);   
});


function updatePrice() {
    //console.log('updatePrice');
    var mainTotalPrice = 0;
    var mainbundlePrice = 0;
    var mainProductPrice = parseInt($('.product-form__variants[name="id"] option:selected').attr('data-price'));
    var bundlePrice = 0;

    var customTotalPrice = mainProductPrice + bundlePrice;
    $('.customizeTotal').html(Shopify.formatMoney(customTotalPrice));
    $('.customizeForm #atcprice').val((customTotalPrice/100).toFixed(2));



    mainTotalPrice = mainProductPrice + mainbundlePrice;
    if ($('select.bundleSelect').length > 0) {
        $('select.bundleSelect').each(function() {
          var bundlePrice = parseInt($(this).find('option:selected').attr('data-price')); 
          mainTotalPrice += bundlePrice;
        });
    }
    if ($('.multiOption:checked').length > 0) {
        $('.multiOption:checked').each(function() {
          var optionPrice = parseInt($(this).attr('data-price')); 
          mainTotalPrice += optionPrice;
        });
    }

    $('.mainForm #origprice').val((mainProductPrice/100).toFixed(2));
    $('.mainForm #atcprice').val((mainTotalPrice/100).toFixed(2));

    $('.customizeForm #origprice').val((mainProductPrice/100).toFixed(2));
    $('.customizeForm #atcprice').val((mainTotalPrice/100).toFixed(2));

    var currencyCode = ' '+Shopify.currency.active;
    if (currencyCode == ' USD') {
        currencyCode = '';
    }
    $('.product__price .price-item--regular').text(Shopify.formatMoney(mainTotalPrice)+currencyCode);


    var updateTimer;  
    if (typeof Afterpay != 'undefined') {
        afterpay_current_variant.price = mainTotalPrice;
        //$('afterpay-placement, square-placement').remove();
        clearTimeout(updateTimer);
        Afterpay.init($) 
        updateTimer = setTimeout(function(){ 
        $('.afterpay-box square-placement').first().nextAll('square-placement').remove()
        }, 300);
    }
    

}


function referrerParam() {
    var docRef = document.referrer;
    var activityVal = '';
    var sportVal = '';
    if (document.referrer.indexOf('search?') > -1) {
        $('.mainForm #atcsrc').val('Search Page');
        $('.customizeForm #atcsrc').val('Search Page');
    }
    if (docRef.indexOf('?') > -1) {
      var docRefParm = getQueryParams(document.referrer.split('?')[1]);
      if (docRefParm.activity != undefined) {
         activityVal = docRefParm.activity.replace(/Activity_/g, '').replace(/,/g, '\|');
      } 
      if (docRefParm.sport != undefined) {
        sportVal = docRefParm.sport.replace(/Sport_/g, '').replace(/,/g, '\|');
      } 
        
    }
    $('.mainForm #atcactivity').val(activityVal); 
    $('mainForm #atcsport').val(sportVal);

    $('.customizeForm #atcactivity').val(activityVal);
    $('.customizeForm #atcsport').val(sportVal);
}

function changeStep(step) {
    currentStep = currentStep + step;
    $('.optionModalBox').attr('data-current-step', currentStep);
    $('.optionStep[data-step="'+currentStep+'"] fieldset input').first().trigger('change');
    checklensButton(currentStep);
    updateOptionProgress(currentStep);
    console.log('changeStep');
}
function checklensButton(currentStep) {
    var stepTxt = $('.optionStep[data-step="'+currentStep+'"]').attr('data-option');
    // console.log(stepTxt);
    // console.log(stepInput);
    // console.log('currentStep:'+currentStep);
    // console.log('lensStep:'+lensStep);
    //console.log('currentStepVal:'+$('.optionStep[data-step="'+currentStep+'"]').attr('data-option'));
    if (stepTxt == lensStep && $('.optionStep[data-option="'+lensStep+'"] .noAdv input:checked').length > 0) {
    //if (stepTxt == lensStep) {
        //console.log('show add lens');    
        //console.log('show add lens');
        $('.chooseLens').show();
    } else {
        //console.log('hide add lens');
        $('.chooseLens').hide();
    }
    
}
function updateOptionProgress(currentStep) {

    var totalStep = $('.optionStep').length;
    var progressPercentage = (currentStep / totalStep) * 100;
    $('.optionModalWrapper .progressBar .progress ').width(progressPercentage+'%');
    if (progressPercentage == 100) {
        // last step
        setTimeout(function(){ 
            buildSummary();
        }, 1);
    }

    //console.log('buildSummary updateOptionProgress', totalStep,progressPercentage);
    //console.log('currentStep:'+currentStep);

    // update step text
    var stepCount = activeSteps.length+1;
    if (progressPercentage >= 100) {
        $('.optionModalInfo .stepCount').text('Final Step');    
    } else {
        $('.optionModalInfo .stepCount').text('Step '+stepCount);  
    }
    // show hide next button
    if($('.optionStep[data-step="'+currentStep+'"] input:checked').length > 0) {
      $('.nextOption.optionActionBtn').show();
    } else {
      $('.nextOption.optionActionBtn').hide();
    }
    // update progress dots
    $('.progressMark dl dt').removeClass('active checked');
    $('.progressMark dl dt[data-step="'+currentStep+'"]').addClass('checked active');


    var duplicateStep = 'Coatings';
    var activeLabel = $('.progressMark dl dt[data-step="'+currentStep+'"]').attr('data-label'); 

    $('.progressMark dl dt').removeClass('hide');
    $('.progressMark dl dt[data-label="'+duplicateStep+'"]').next('[data-label="'+duplicateStep+'"]').addClass('hide');

    if (activeLabel == duplicateStep) {
      $('.progressMark dl dt[data-label="'+duplicateStep+'"]').addClass('active');
    }

    $.each(activeSteps, function(index, item) {
        $('.progressMark dl dt[data-step="'+item+'"]').addClass('checked');
    });
    setTimeout(function() {
        $.each(activeSteps, function(index, item) {
            var thisOption = $('.optionStep[data-step="' + item + '"] .optionSelect[data-option]');
            var customValue = thisOption.attr('data-value').trim().toLowerCase().replace(/\s+/g, '-');
            console.log(customValue);
            $('.customizeSection').attr('option-'+item, customValue);
        });  
    }, 100);
    
}
function buildSummary() {
    console.log('buildSummary');
    var prevStep = 'Step 1';
    $('#customTimestamp').val(Math.floor(Date.now() / 1000));
    $('.optionModalWrapper').attr('data-id', $('.main-product-variants').val());
    $('#customVariantID').val($('.main-product-variants').val());

    $('.customProperties').html('');
    $('.selectedProperty').html('');

    let optSize = $('.mainForm .selector-wrapper[data-option][data-option]').length;


    $('.mainForm .selector-wrapper[data-option][data-option]').each(function(index) {
        let xIndex = index + 1;
        var optionTitle = $(this).data('option-name');
        var optionValue = $(this).find('.single-option-selector').val();
        var prodType = $('.optionModalWrapper').attr('data-type');
        var isFrame = false; //;
        const prodPriceText = $('.price__regular [data-regular-price]').text();

        if (prodType == 'Frame' || prodType == '') {
            prodType = 'Frame';
            isFrame = true;
        } 
        //console.log('optionTitle:'+optionTitle);
        if (optionTitle == 'Color') {
            optionTitle = prodType+' Color'
        } else if (optionTitle == 'Size') {
            optionTitle = prodType+' Size' 
        }
        var prodPrice = '';
        if (xIndex == 1) {
            if (prescriptionFlag && discountFlag) {
                const prodPriceDecimal = parseFloat(prodPriceText.replace(/[$,]/g, ""));
                const prodPriceSale = `$${(prodPriceDecimal * discount100Decimal).toFixed(2)}`;
                prodPrice = `<em><span class="sale">${prodPriceSale}</span> <s>${prodPriceText}</s></em>`;
            } else {
                prodPrice = `<em>${prodPriceText}</em>`;
            }  
        }
         
        $('.selectedProperty').append('<dt><strong>'+optionTitle+'</strong></dt><dd>'+optionValue+prodPrice+'</em></dd>');
        $('.customProperties').append('<input type="hidden" name="properties[_'+optionTitle+']" value="'+optionValue+'" />'); 

    });
    var noTYArr = $('.optionStep.reviewStep').attr('data-no-thanks').split('| ');
    var customizeAddons = [];
    $.each(activeSteps, function(index, item) {
        
        var thisOption = $('.optionStep[data-step="' + item + '"] .optionSelect[data-option]');
        var customKey = thisOption.attr('data-option').split(': ')[0];
        var bundlePrice = thisOption.attr('bundle-price');
        var customValue = thisOption.attr('data-value');

        var customPrice = $.trim(thisOption.attr('data-price-text'));



        
        if (customPrice.indexOf('+') > -1) {
            var match = customPrice.match(/(\+\$\d+(?:\.\d+)?)\s+(\$\d+(?:\.\d+)?)/);
            if (match) {
                var discount = match[1];
                var original = match[2];
                // Replace content with HTML
                customPrice = '<span class="sale">' + discount + '</span> <s>' + original + '</s>';
            }
        }

        if (jQuery.inArray(customValue, noTYArr) > -1) {
            customValue = '';
        }
        // if non prescription skip prescription option
        if (customKey.toLowerCase().indexOf('prescription option') > -1 && prescriptionFlag == false) {
            $('.optionStep  .uploadField').val('');
            customKey = '';
        }
        if (customKey.toLowerCase().indexOf('prescription option') > -1 && customValue.toLowerCase().indexOf('upload') > -1) {
            customValue = 'Attached Prescription: '+$('.uploadFieldBox .uploadField').val().split('\\').pop();
        }
        var xPrice = '<em>' + customPrice + '</em>';
        if (prevStep == customKey) {

            var xValue = $('.customProp[title="'+customKey+'"]').val()+', '+customValue;
            

            if ($('.selectedProperty dd[title="'+customKey+'"]').length == 0) {
                $('.customProperties').append('<input title="'+customKey+'" type="hidden" class="customProp" name="properties[' + customKey + ']" value="' + customValue + '" />');
                $('.selectedProperty').append('<dt class="aaa"><strong>' + customKey + '</strong></dt><dd title="'+customKey+'">' + customValue +xPrice+'</dd>');
            } else {
                $('.customProp[title="'+customKey+'"]').val(xValue);
                //$('.selectedProperty dd[title="'+customKey+'"]').html(xValue+xPrice); 
                $('.selectedProperty').append('<dd title="'+customKey+'">' + customValue +xPrice+'</dd>');
            }

            if (customKey != '' && customValue != '') {
                if (customKey != 'Prescription Option') {
                    if (customValue != 'Non-prescription') {
                        customizeAddons.push(customKey+' - '+customValue);
                    }
                }
            }    
        } else {
            if (customKey != '' && customValue != '') {

                let coatingPrice = xPrice;
                if (prescriptionFlag && discountFlag) {
                    if (customPrice != '' && customPrice != 'Free'  && customPrice.indexOf('sale') == -1) {
                       
                        const prodPriceDecimal = parseFloat(customPrice.replace(/[+$,]/g, ""));
                        const prodPriceSale = `$${(prodPriceDecimal * discount100Decimal).toFixed(2)}`;                        

                        coatingPrice = `<em><span class="sale">+${prodPriceSale}</span> <s>${customPrice.replace("+", "")}</s></em>`;
                    }
                    
                } 
                $('.customProperties').append('<input title="'+customKey+'" type="hidden" class="customProp" name="properties[' + customKey + ']" value="' + customValue + '" />');
                $('.selectedProperty').append('<dt class="bbb"><strong>' + customKey + '</strong></dt><dd title="'+customKey+'">' + customValue.replace(/,/g, ', ') +coatingPrice+ '</dd>');
                if (customKey != 'Prescription Option') {
                    if (customValue != 'Non-prescription') {
                        customizeAddons.push(customKey+' - '+customValue);
                    }
                }
                
            }
        }
        prevStep = customKey;
    });
    

    if (prescriptionFlag == false && nonPrescOpt != '') {
        
        var nonPrescOptArr = nonPrescOpt.split('; ');
        var xbundlePrice = 0;
        var mainProductPrice = parseInt($('.product-form__variants[name="id"] option:selected').attr('data-price'));
        $.each( nonPrescOptArr, function( key, value ) {
            var valueArr = value.split(':');
            var xKey = valueArr[0];
            var xValue = valueArr[1];

            var bundlePrice = parseInt($('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').attr('data-price'));
            var customKey = $('.bundleStep[data-handle="'+xKey+'"] .optionSelect').attr('data-option').split(': ')[0];
            var customPrice = $('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').closest('label').find('em').text();
            var customValue = $('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').attr('data-value');

            var xPrice = '<em>' + customPrice + '</em>';

            $('.customProperties').append('<input type="hidden" class="customProp" name="properties[' + customKey + ']" value="' + customValue + '" />');
            $('.selectedProperty').append('<dt class="ccc"><strong>' + customKey + '</strong></dt><dd>' + customValue +xPrice+ '</dd>');

            xbundlePrice += bundlePrice; 
        });
        // console.log('xbundlePrice:'+xbundlePrice);
        // console.log('mainProductPrice:'+mainProductPrice);
        $('.customizeTotal').html(Shopify.formatMoney(mainProductPrice+xbundlePrice));
        $('.customizeForm #atcprice').val((mainProductPrice+xbundlePrice/100).toFixed(2));
        $('.mainForm #atcprice').val((mainProductPrice+xbundlePrice/100).toFixed(2));
        
    } 
    
    if (customizeAddons.toString() == '') {
        $('.customizeForm #atcaddons').remove();
    } else {
        $('.customizeForm #atcaddons').remove();
        $('.customizeForm').prepend('<input type="hidden" id="atcaddons" name="properties[_AddOnList]" value="'+customizeAddons.toString().replace(/,/g, '\|')+'" />');
    }
    //console.log('_AddOnList', customizeAddons.toString().replace(/,/g, '\|'));
}
function updateCustomizeOptions() {
    $('select.single-option-selector').each(function() {
        var dataName = $(this).attr('data-name');
        // show hide option
        $('.optionSelect[data-option="' + dataName + '"] label').hide();
        $(this).find('option').each(function() {
            $('.optionSelect[data-option="' + dataName + '"] label[data-value="' + $(this).attr('value') + '"]').show();
        });
        // show hide option disclaimer
        var currentOptionCount = parseInt($('.optionSelect[data-option="' + dataName + '"]').attr('option-count'));
        var visibleOptionCount = $(this).find('option').length;
        var currentDisclaimer = $('.optionSelect[data-option="' + dataName + '"]').closest('.optionStep').find('.optionDisclaimer')
        if (currentOptionCount > visibleOptionCount) {
            currentDisclaimer.show();
        } else {
            currentDisclaimer.hide();
        }
    });    
}

function filterGallery(filter, scrollPos, currentGalleryIndex) {
    $(".productSlider").slick('slickUnfilter');
    
    //console.log('filter: '+filter);
    // if filter is not present set the alt value
    if (filter == '') {
        filter = $('.gallerySlide').first().attr('data-alt');
    }
    
    var optImage;
    var singleOpts;

    var noAutoAdvVal = $('.optionSlider .optionStep[data-auto-adv="false"] input:radio:checked').attr('data-value');
    var noAutoAdvStep = $('.optionSlider .optionStep[data-auto-adv="false"]').attr('data-handle');
    $('.optionModalImage .optionImage').each(function(idx) {
        //console.log('idx: '+idx);
        var galleryOpt = $(this).attr('data-option')+',';
        //console.log('galleryOpt: '+galleryOpt);
        var optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').attr('href');

        var thisStep = $(this).attr('data-option');

        if (noAutoAdvVal != undefined) {
            //var lensOpt = $('.optionSlider .optionStep[data-option*="lens color"] input:radio:checked').attr('data-value');
            if ($(this).attr('data-option').indexOf(noAutoAdvStep) > -1) {
                //console.log('aaaaaaaaaa');
                optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"][data-lens="'+noAutoAdvVal+'"] a').attr('href');
            } else {
                //console.log('bbbbbbb');

                optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"][data-lens="'+noAutoAdvVal+'"] a').attr('href');  
                if (optImage === undefined) {
                  optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').attr('href');     
                } 
                if (optImage === undefined) {
                    optImage = $('.gallerySlide[data-alt="'+filter+'"] a').first().attr('href'); 
                } 
            }
            
        } else {
            //console.log('cccc');
            optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').first().attr('href');

            if (optImage === undefined) {
                optImage = $('.gallerySlide[data-alt="'+filter+'"] a').first().attr('href'); 
            } 
        }
        if (optImage != undefined) {
            optImage = optImage.replace('_1920x1920.', '_1600x1600.')
        }  
                       //console.log('optImage2:'+optImage);              
        $(this).find('.imageBox').html('<img src="'+optImage+'" loading="lazy" />');
        
    });
    $('.optionBody .optionImage').each(function(idx) {
        //console.log('idx: '+idx);
        var galleryOpt = $(this).attr('data-option')+',';
        //console.log('galleryOpt: '+galleryOpt);
        var optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').attr('href');

        var thisStep = $(this).attr('data-option');

        if (noAutoAdvVal != undefined) {
            //var lensOpt = $('.optionSlider .optionStep[data-option*="lens color"] input:radio:checked').attr('data-value');
            if ($(this).attr('data-option').indexOf(noAutoAdvStep) > -1) {
                //console.log('aaaaaaaaaa');
                optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"][data-lens="'+noAutoAdvVal+'"] a').attr('href');
            } else {
                //console.log('bbbbbbb');

                optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"][data-lens="'+noAutoAdvVal+'"] a').attr('href');  
                if (optImage === undefined) {
                  optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').attr('href');     
                } 
                if (optImage === undefined) {
                    optImage = $('.gallerySlide[data-alt="'+filter+'"] a').first().attr('href'); 
                } 
            }
            
        } else {
            //console.log('cccc');
            optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').first().attr('href');

            if (optImage === undefined) {
                optImage = $('.gallerySlide[data-alt="'+filter+'"] a').first().attr('href'); 
            } 
        }
        if (optImage != undefined) {
            optImage = optImage.replace('_1920x1920.', '_1600x1600.')
        }  
                       //console.log('optImage2:'+optImage);              
        $(this).find('.imageBox').html('<img loading="lazy" src="'+optImage+'" class="jsloaded" />');
        
    });

    /*
    var optImage;
    $('.optionBody .optionImage').each(function() {
        var galleryOpt = $(this).attr('data-option')+',';
        var optImage = $('.gallerySlide[data-alt="' + filter + '"][data-option*="' + galleryOpt + '"] a').attr('href');
        //undefined get the first image
        if (optImage === undefined) {
            optImage = $('.gallerySlide[data-alt="' + filter + '"] a').first().attr('href');
        }
        optImage = optImage.replace('_1920x1920.', '_640x640.')
        $(this).find('.imageBox').html('<img src="https://cdn.shopify.com/s/files/1/3102/1374/files/loading.gif?v=1622658523" data-src="' + optImage + '" class="lazyload" />');
    });
    */


    if ($.inArray(filter, altArray) != -1) {
        $('.productSlider').slick('slickFilter', '[data-alt="' + filter + '"]');
        //$('.productSlider').slick('slickAdd', '<div class="gallerySlide ">New Slide</div>');
        // add corerct index and go to slide 0
        $('.tmbNav li:not(".slick-cloned")[data-alt="'+filter+'"]').each(function(index) {
            $(this).attr('data-slick-index', index);
        });
        //$('.productSlider').slick('slickGoTo', currentGalleryIndex);
    } else {
        // nothing to filter add correct index and go to slide 0
        $('.tmbNav li:not(".slick-cloned")').each(function(index) {
            $(this).attr('data-slick-index', index);
        });
        //$('.productSlider').slick('slickGoTo', 0);
    }
    $('.productGallery').removeClass('noTrack');
    if ($('.productGallery .tmbNav .slick-list').width() >= $('.productGallery .tmbNav .slick-track').width()) {
        $('.productGallery').addClass('noTrack');
    }

    // prevent auto scroll
    var scrollPosAfter =    $(window).scrollTop(); 
    var scrollDiff = scrollPosAfter - scrollPos;
    if (scrollDiff > 0 ) {
        $("html, body").animate({
         scrollTop: scrollPos
        }, 0);
    }        
} 

function addtoCartAddons() {
    $.ajaxSetup({
        async: false,
    });
    var addOnArray = [];
    var addOnTitleArr = [];
    var customProp = {};

    // if has add on bundle
    $('.addOnProperties').html('');
    if ($('.bundleSelect').length > 0 || $('.multiOption:checked').length > 0 ) {
        var selectedVariantID = $('.product-form__variants[name="id"]').val();

        var bundleTS = Math.floor(Date.now() / 1000);
        var addOnProperty = {};
        addOnProperty['_Timestamp'] = bundleTS;
        addOnProperty['_Product Title'] = $('.mainForm').data('product-title');
        addOnProperty['_Product ID'] = $('.mainForm').data('product-id');
        addOnProperty['_Product ID'] = $('.mainForm').data('product-id');
        addOnProperty['_HR'] = '-----';



        $('.addOnProperties').append('<input type="hidden" name="properties[_Timestamp]" value="'+bundleTS+'" />');
        $('.multiOption:checked').each(function(index) {
            var indexNo = index + 1;
            var itemProp = $(this).attr('name')+' #'+indexNo;
            //parentProperty[itemProp] = $(this).data('title');
            $('.addOnProperties').append('<input type="hidden" name="properties['+itemProp+']" value="'+$(this).data('title')+'" />');
            addOnArray.push($(this).val());
            addOnTitleArr.push($(this).data('title').split(' [')[0]);
            // push customProp 
            customProp[itemProp] = $(this).data('title').split(' [')[0];
        });
       
        $('.bundleSelect').each(function(index) {
            var selectlabel = $(this).closest('.selector-wrapper').data('label');
            var selectedOption = $(this).find('option:selected');
            if (selectlabel != undefined && selectedOption != undefined) {
                $('.addOnProperties').append('<input class="bundleSelectVal" type="hidden" name="properties['+selectlabel+']" value="'+selectedOption.data('title')+'" />');
                if (selectedOption.data('price') > 0) {
                    //parentProperty[selectlabel] = selectedOption.data('title');
                    addOnArray.push($(this).val());
                    addOnTitleArr.push($(this).val());
                }
            }
            customProp[selectlabel] = selectedOption.data('title');
        }); 
        $('.addOnProperties').append('<input type="hidden" name="properties[_AddOnList]" value="'+addOnTitleArr.toString().replace(/,/g, '\|')+'" />');
        $('.addOnProperties').append('<input type="hidden"  name="properties[_HR]" value="-----" />');


        // klaviyo 
        pushItem($('.mainForm'), addOnArray, 'Added to Cart', customProp);
        //has add on selected
        if (addOnArray.length > 0) {
            var addOnCount = addOnArray.length;
            
            $.each(addOnArray, function(key, value) {
                var addOnParams = {
                    quantity: 1,
                    id: value
                };
                addOnParams.properties = addOnProperty;
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    async: false,
                    data: addOnParams,
                    success: function() {
                        //alert('ajax success add');
                    },
                    error: function() {}
                });
            });
            
            //console.log('loop finish submit main form');
            //alert('submit form');
            setTimeout(function() {
                $('.mainForm').submit();
            }, 600);
            
        } else {
            //console.log('submit without add on')
            pushItem($('.mainForm'), addOnArray, 'Added to Cart', customProp);
            setTimeout(function() {
                $('.mainForm').submit();
            }, 600);
        }
        
    } else {
        // normal submit
        //console.log('normal add', addOnProperty);
        pushItem($('.mainForm'), addOnArray, 'Added to Cart', customProp);
        setTimeout(function() {
            $('.mainForm').submit();
        }, 600);
    }
    $.ajaxSetup({
        async: true, 
    });
}

function pushItem(form, addOnArray, event, properties) {
    //console.log('pushItem', 'event:'+event, addOnArray, properties);
    
    var form = form;
    var category = window.location.pathname === '/search' ? $item.data('cat').split(' - ')[0] : $('.collectionBox ').attr('data-name');
    var $item = form.closest('.product-single');
    var bundleArr = '';
    var bundleAttr = '';
    if (properties === undefined) {
        properties = [];
    }

    if (addOnArray != '') {
        var bundleTitle = 'Addons';
        var bundleArr = ''
        var bundleAttr = '';

        $.each(addOnArray, function( key, value ) {
            if (key == 0) {
                bundleArr += value;
            } else {
                bundleArr += ';'+value;
            }
        });

        if(window.location.href.indexOf('?') > -1) {
            bundleAttr = '&'+bundleTitle+'='+bundleArr;
        } else {
            bundleAttr = bundleTitle+'='+bundleArr;
        }
    }

    var cItem = {
        Name: $item.find('.product-single__title').text(),
        ProductID: form.attr('data-product-id'),
        Categories: [category],
        Proprties: properties,
        ImageURL: 'https:'+$item.find('.main-product-variants option:selected').attr('data-image'),
        URL: 'https://'+window.location.host+'/products/'+form.attr('data-handle')+'?variant='+$('.main-product-variants').val()+bundleAttr,
        Brand: $item.find('.product-single__vendors').text(),
        Price: $.trim($item.find('.price__pricing-group [data-regular-price]').first().text())
    }
    //console.log(cItem);
    if (typeof window._learnq !== 'undefined') {
        console.log("Klaviyo is defined.");
        if (_learnq != undefined) {
            _learnq = _learnq || [];

            if (event == 'Added to Cart') {
                _learnq.push(['track', 'Added to Cart', cItem]);
            }
            if (event == 'Viewed Product') {
                _learnq.push(['track', 'Viewed Product', cItem]);
            }
        }
    }
}


function filterSwatches() {
    var firstAvailOpt1 = $('.single-option-selector[data-index="option1"]').val();
    var firstAvailOpt2 = $('.single-option-selector[data-index="option2"]').val();

    if (firstAvailOpt1 != undefined && firstAvailOpt2 != undefined) {
        $('.swatch[data-option-index="0"]  .swatch-element').addClass('unavailable');
        $('.main-product-variants option[data-option2="' + firstAvailOpt2 + '"]').each(function() {
            $('.swatch[data-option-index="0"] .swatch-element[data-value="' + $(this).attr('data-option1') + '"]').removeClass('unavailable');
        });

        $('.swatch[data-option-index="1"] .swatch-element').addClass('unavailable');
        $('.main-product-variants option[data-option1="' + firstAvailOpt1 + '"]').each(function() {
            $('.swatch[data-option-index="1"] .swatch-element[data-value="' + $(this).attr('data-option2') + '"]').removeClass('unavailable');
        });

        var selectedNone1 = $('.swatch[data-option-index="1"] .swatch-element.unavailable input:checked').length;
        if (selectedNone1 > 0) {
            $('.swatch[data-option-index="1"] .swatch-element').not('.unavailable').first().find('input').prop('checked', true);
        }
    }
}

var reqCount = 0;

Shopify.moveAlong = function() {

    if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
    } else {
        //document.location.href = '/cart';
    }
};
Shopify.addItem = function(id, qty, properties, callback) {
    var params = {
        quantity: qty,
        id: id
    };
    if (properties != false) {
        params.properties = properties;
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        success: function() {
            if (typeof callback === 'function') {
                callback();
            }
        },
        error: function() {
            alert('error');
        }
    });
}

function push_to_queue(variantID, quantity, properties, callback) {
    Shopify.queue.push({
        variantId: variantID,
        quantity: quantity,
        properties: properties
    });
    if (typeof callback === 'function') {
        callback();
    }
}


function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function showHideOpts() {
    var showHideOptionVal = $('.optionModalWrapper').attr('data-show-option');
    var showHideOptionValArr = showHideOptionVal.split('; ');

    $('.optionStep .optionSelect label').closest('label').show();
    $.each(showHideOptionValArr, function(index, value) {
        var valueArr = value.split(' = ');
        var valueKey = valueArr[0].split(':: ');
        var valueVal = valueArr[1];


        var selectedOpt = $('.optionStep[data-option="' + valueKey[0] + '"] .optionSelect input[data-value-lowercase="' + valueKey[1] + '"]:checked').length;
        if (selectedOpt > 0) {
          var stepKey = valueArr[1].split(':: ')[0];
          var stepValArr = valueArr[1].split(':: ')[1].split('| ');

          console.log('stepKey:'+stepKey);

          $('.optionStep[data-option="' + stepKey + '"] .optionSelect label').closest('label').hide();
          $.each(stepValArr, function(k, v) {
              $('.optionStep[data-option="' + stepKey + '"] .optionSelect input[data-value-lowercase="' + v + '"]').closest('label').show();
          });

        }
    });
}


function showHideBundleOpt() {  
    //console.log('showHideBundleOpt');
    var showHideOpts = $('.product-form__controls-group').attr('data-show-option');
    if (showHideOpts != undefined) {
        if (showHideOpts != '') {
            var showHideOptsArr = showHideOpts.split('; ');
            $.each(showHideOptsArr, function(key, value) {
                //console.log(value);
                var optLabel = value.split(':: ')[0];
                var optValue = value.split(' = ')[0].split(':: ')[1];
                var selectedOption = $('.bundleSelect[data-label="' + optLabel + '"] option:selected').attr('data-title');
                if (optValue == selectedOption) {
                    var optHidelabel = value.split(' = ')[1].split(':: ')[0];
                    var optHideValueArr = value.split(' = ')[1].split(':: ')[1].split('| ');


                    $('.bundleSelect[data-label="' + optHidelabel + '"] option').each(function() {
                        var optTitle = $(this).attr('data-title');
                        var titleInArr = $.inArray(optTitle, optHideValueArr)
                        $(this).removeAttr('disabled');

                        if (titleInArr == -1) {
                            $(this).attr('disabled', 'disabled');
                            $(this).prop("selected", false)
                        }
                        //$(this).closest('select').find('option').not('[disabled]').first().prop("selected", true);
                    });

                }
            });
        }
    }
}

function loadCustomizer() {
    var prodHandle = $('.customizeSection').attr('data-handle');
    $('body').addClass('ajaxLoading');
    $('.customizeSection').load(window.location.pathname+'?view=customizer', function() {
        applyDiscountPrice();
        referrerParam()  
        nonPrescOpt = $('.optionModalWrapper').attr('data-non-prescription-opts');
        var filter = $('select.single-option-selector[data-name="Color"] option:selected').val();
        $('.optionStep  .uploadField').val('');
        if (filter == undefined) {
            filter = '';    
        }
        filter = filter.replace(/\W+(?!$)/g, '-').toLowerCase();
        filter = filter.replace(/\W$/, '').toLowerCase();
        
        var scrollPos =    $(window).scrollTop(); 

        console.log(filter);
        console.log(scrollPos);
        console.log(currentGalleryIndex);
        filterGallery(filter, scrollPos, currentGalleryIndex);


        $('body').removeClass('ajaxLoading');

        var optsActionHTML  = '<span class="actionBox"><button type="button" class="chooseMe">Choose this lens</button><button type="button" class="cancel">Cancel</button></span>';
        $('.optionStep[data-auto-adv="false"] .optionSelect label').each(function() {
            
            var optInput = $(this).find('input[type="radio"]');
            var optTitle = $(this).closest('.optionStep').attr('data-handle');
            var inArr = $.inArray(optTitle, advOptsArr); 

            if (inArr > -1) {
                lensStep = $(this).closest('.optionStep').attr('data-option');
                $(this).addClass('noAdv');
                optInput.attr('data-advance', 0);
                $(this).find('.actionBox').remove();
                $(this).append(optsActionHTML);
            }
        });
        // set skip steps option
        var nextOptionVal = $('.optionModalWrapper').attr('data-next-steps');
        //console.log(nextOptionVal);
        if (nextOptionVal != '') {
            var nextOptionValArr = nextOptionVal.split('; ');
            $.each(nextOptionValArr, function(index, value) {
                var valueArr = value.split(' = ');
                var valueKey = valueArr[0].split(': ');
                var valueVal = valueArr[1];
                $('.optionStep[data-option="' + valueKey[0] + '"] .optionSelect input[data-value-lowercase="' + valueKey[1] + '"]').attr('data-next-step', valueVal);
            });
        }

        $('.optionSlider .optionStep .heading h3').each(function() {
            $(this).closest('.optionStep').find('.optionImage').after('<h3 class="optionHead">'+$(this).text()+'</h3>')
        });

        // set show hide option
        if ($('.optionModalWrapper').length > 0) {
            var showHideOptionVal = $('.optionModalWrapper').attr('data-show-option');
            if (showHideOptionVal != '') {
                var showHideOptionValArr = showHideOptionVal.split('; ');
                $.each(showHideOptionValArr, function(index, value) {
                    var valueArr = value.split(' = ');
                    var valueKey = valueArr[0].split(': ');
                    var valueVal = valueArr[1];
                    $('.optionStep[data-option="' + valueKey[0] + '"] .optionSelect input[data-value-lowercase="' + valueKey[1] + '"]').attr('data-next-option', valueVal);
                });
            }
        }
        setTimeout(function() {
          var varImg = $('.main-product-variants option:selected').attr('data-image');
          $('.atcurl').val(window.location.href);    
          $('.atcimage').val(varImg);    
        }, 100);
        showHideOpts();
    });
}
function buildGalleryImages(data, img, alt) {
    var html = ''
    var sizeArr = ['481:657', '361:448', '328'];
    var sizeArrSize = sizeArr.length - 1;
    var xSizes = '';
    var xSrcsets = '';
    $.each(sizeArr, function(key, value) {
        var imgSizeArr = value.split(':');
        if (key != sizeArrSize) {
            xSizes += '(min-width: ' + imgSizeArr[0] + 'px) ' + imgSizeArr[1] + 'px, ';

            var imgXsrc = data.replace('.jpg', '_' + imgSizeArr[1] + 'x.jpg').replace('.png', '_' + imgSizeArr[1] + 'x.png').replace('.webp', '_' + imgSizeArr[1] + 'x.webp') + ' ' + imgSizeArr[1] + 'w, ';
            xSrcsets += imgXsrc;
        } else {
            xSizes += imgSizeArr[0] + 'px';
            var imgXsrc = data.replace('.jpg', '_' + imgSizeArr[0] + 'x.jpg').replace('.png', '_' + imgSizeArr[0] + 'x.png').replace('.webp', '_' + imgSizeArr[0] + 'x.webp') + ' ' + imgSizeArr[0] + 'w';
            xSrcsets += imgXsrc;
        }
    });
    $(img).attr('sizes', xSizes).attr('srcset', xSrcsets).attr('alt', alt);
}



/*
$(document).ready(function() {
    // if (appliedCode != theme.custom.customDiscountCode && theme.custom.customDiscountAutoApply) {
    //   window.location.href =  $('.pdpAutoDiscountLink').attr('href');
    // } 
    if (theme.custom.autoDiscount && allProductTag.includes(theme.custom.autoDiscountTag)) {
        $('[data-pdp-discount-badge]').html('<strong>'+theme.custom.autoDiscountMsgPDP+'</strong>');
    } 


    const prodTypeArr = $('[data-pdp-type]').attr('data-pdp-type').split(', ');
    const setB = new Set(theme.custom.customDiscountProdTypes);
    const hasSimilarities = prodTypeArr.some(type => setB.has(type));

    if (appliedCode == theme.custom.customDiscountCode && hasSimilarities) {
       $('[data-pdp-discount-badge]').html('<strong>'+theme.custom.customDiscountAppliedMsgPDP+'</strong>');
    }    

    applyDiscountPrice();
});
*/
function applyDiscountPrice() {
    discountFlag = false;
    const allProductTag = $('[data-pdp-tag]').attr('data-pdp-tag').split(', ');


    if (theme.custom.autoDiscount && allProductTag.includes(theme.custom.autoDiscountTag)) {
        discountFlag = true;
        appliedDiscount = theme.custom.autoDiscountPercentage;
        discount100Decimal = 1 - (appliedDiscount / 100);
    }

    if (theme.custom.appliedDiscountCode == theme.custom.customDiscountCode) {
        appliedDiscount = theme.custom.customDiscountPercentage;
        discount100Decimal = 1 - (appliedDiscount / 100);
        discountFlag = true;
    }

    if (discountFlag) {
      $('[data-price-discount-no-zero]').each(function() {
        var priceText = $(this).attr('data-price-discount-no-zero');
        var priceVal = parseFloat(priceText.replace(/[^0-9.]/g, ''));

        var priceDiscount = priceVal * discount100Decimal;

        $(this).addClass('sale').find('s').html('$'+priceVal.toFixed(2));
        $(this).find('span').html('$'+priceDiscount.toFixed(2));
      });
    } else {
      $('[data-price-discount-no-zero]').each(function() {
        var priceText = $(this).attr('data-price-discount-no-zero');
        $(this).removeClass('sale').find('s').html('');
        $(this).find('span').html(priceText);
      });  
    }
}



$(function() {
    var $actionBox = $('.pdpActionBox');
    var $stickyAtc = $('[data-sticky-atc]');

    var $actionBox = $('.pdpActionBox');
    var $stickyAtc = $('[data-sticky-atc]');

    if (!$actionBox.length || !$stickyAtc.length) return;

    $(window).on('scroll resize', function() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var elementTop = $actionBox.offset().top;
        var elementBottom = elementTop + $actionBox.outerHeight();

        var isPast = scrollTop > elementBottom;
        var isVisible =
            elementBottom > scrollTop &&
            elementTop < scrollTop + windowHeight;

        if (isPast && !isVisible) {
            $stickyAtc.addClass('is-visible');
        } else {
            $stickyAtc.removeClass('is-visible');
        }
    }).trigger('scroll');

    $('[data-sticky-atc-add]').on('click', function(e) {
        e.preventDefault(); // prevent default link behavior if it's a link

        var $target = $('.product-form__controls-group');
        if ($target.length) {
            var headerHeight = $('#shopify-section-redesign-header').outerHeight() || 0; // get header height
            var scrollPosition = $target.offset().top - headerHeight;
            var isAvail = true;
            if ($(this).hasClass('is-disabled')) {
                isAvail = false;
            }

            $('html, body').animate(
              {
                scrollTop: scrollPosition
              },
              300,
              function () {
                if (isAvail) {
                    $('.customizeBtn').trigger('click')
                }
              }
            );
        }
    });
});

$(document).ready(function() {
	$('.productGrid').on('click', '.customCard .swatches-inner label', function(e) {
	    var imgURL = $(this).data('image');
	    var prodCard = $(this).closest('.product-card');
	    prodCard.find('.product-card__image').attr('src', imgURL);
	    prodCard.find('.c-color-swatches__swatch').removeClass('active');
	    $(this).addClass('active');
	    return false;
	});
	//$('.productGrid .customCard .swatches-row').matchHeight({ property: 'min-height'});
	$('.productGrid .customCard .card__information').matchHeight();
}); 


